import { ComponentType as d } from "../../registries/types/propTypes.js";
import { displayCardTransformer as n } from "./featured-display-card-transformer.js";
const u = (r) => {
  const e = Array.isArray(r == null ? void 0 : r.featured_display_cards_carousal) ? r == null ? void 0 : r.featured_display_cards_carousal[0] : [], s = (a) => a == null ? void 0 : a.map((o) => {
    const [t] = o.featured_card;
    return {
      ...n(t)
    };
  });
  return {
    componentType: d.featured_card_container,
    displayTitle: e.title,
    heading: e.display_heading,
    viewAllLink: e.view_all,
    featuredCradsList: s(e.items)
  };
};
export {
  u as default
};
//# sourceMappingURL=featuredCardsTransformer.js.map
